// extracted by mini-css-extract-plugin
module.exports = {"root":"Video-module__root___2YO4G","video":"Video-module__video___EtLiA"};